import { storeToRefs } from "pinia";

import { getLocale, getLocaleText } from "shared/boot/i18n";
import { useGlobalStore } from "shared/stores/global";

function currencyFormat() {
  const { isStreem } = storeToRefs(useGlobalStore());
  const currency = isStreem.value ? "AUD" : getLocaleText("currency");

  return new Intl.NumberFormat(getLocale(), { style: "currency", currency });
}

export default function toCurrency(value) {
  return currencyFormat().format(value);
}
